export default class CallkitPluginServer {}
